export default class CallkitPluginServer {}
